module.exports = __webpack_public_path__ + "img/kleisma1-m@2.58f01711.jpg";